import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-[calc(100vh-66px)] bg-white flex flex-col justify-center items-center" }
const _hoisted_2 = { class: "gray" }
const _hoisted_3 = { class: "flex w-fit justify-start pl-20" }
const _hoisted_4 = { class: "flex justify-self-center justify-center items-center gap-30 pt-14 pl-20 pr-[75px] w-fit" }
const _hoisted_5 = { class: "ml-10" }
const _hoisted_6 = ["src"]

import betaFormImage from "@/assets/images/lead-form-image.svg";

export default /*@__PURE__*/_defineComponent({
  __name: 'PostSubmission',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_snap_logo = _resolveComponent("snap-logo")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_snap_logo, {
          product: "snap-logo-store",
          white: "false",
          variant: "1line"
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "text-[#051C31] font-bold font-inter text-4xl leading-[50px] md:w-[461px]" }, [
          _createTextVNode(" Thanks for your submission. Our team will be reaching out to you upon receiving your submission "),
          _createElementVNode("p", { class: "text-sm font-medium text-[#051C31]" }, "Stores may take anywhere from 10-15 business days to create.")
        ], -1)),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("img", {
            id: "lead-form-image",
            src: _unref(betaFormImage),
            alt: "betaFormImage"
          }, null, 8, _hoisted_6)
        ])
      ])
    ])
  ]))
}
}

})